export default __webpack_public_path__ + "static/media/program_intro_12.04ddaec3.png";